export function useUpdateQueryParams() {
  const updateQueryParams = newParams => {
    const searchParams = new URLSearchParams(window.location.search);
    Object.keys(newParams).forEach(key => {
      if (newParams[key] !== undefined) {
        searchParams.set(key, newParams[key]);
      } else {
        searchParams.delete(key);
      }
    });
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, '', newUrl);
  };
  return updateQueryParams;
}